import { useSelector } from "react-redux";

const CustomHeader = (props) => {
  const showHeader = useSelector((state) => state.mode.showHeader) === "true";

  return (
    <>
      {showHeader && (
        <div className="header" role="banner">
          <div style={{ color: "#404040" }}>
            <h1>{props.text}</h1>
          </div>
        </div>
      )}
    </>
  );
};

export default CustomHeader;
